import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Layout from "./components/site/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import PrivateLabelPage from "./pages/PrivateLabelPage";
import WholesalePage from "./pages/WholesalePage";
import SustainabilityPage from "./pages/SustainabilityPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="font-serif-display italic text-[#E85D2F] text-xl">404</p>
      <h1 className="mt-4 font-grotesk text-5xl md:text-7xl font-black tracking-tighter text-[#F7F5F0]">
        Page not found.
      </h1>
      <a
        href="/"
        className="mt-8 rounded-full bg-[#E85D2F] text-[#0A0A09] px-7 py-3 font-medium hover:bg-[#F47A4A] transition-colors"
      >
        Back to home
      </a>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/private-label" element={<PrivateLabelPage />} />
            <Route path="/wholesale" element={<WholesalePage />} />
            <Route path="/sustainability" element={<SustainabilityPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121211",
              color: "#F7F5F0",
              border: "1px solid rgba(212,184,149,0.25)",
              borderRadius: "16px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
